module.exports = __webpack_public_path__ + "static/media/macaw.402347c1.svg";